<template>

<div>
<v-layout my-3>
  <v-flex xs12 sm6 offset-sm3>
    <v-card>
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-3">About</h3>
          <div>
            <p>MECVision is a Progressive Web App (PWA) that uses computer vision (object detection) to estimate the number of mosquito eggs on ovitrap paper.</p>
            <p>Check out the <a href="https://github.com/abtassociates/mecvision">project page</a> if you would like to contribute to the MECVision project or adapt it for your own purposes.</p>
            <p>This MECVision project was developed by <a href="https://www.abtassociates.com">Abt Associates</a> with support from the <a href="https://www.usaid.gov">United States Agency for International Development (USAID)</a>'s <a href="https://www.usaid.gov/documents/1862/zika-airs-project-zap">Zika AIRS Project (ZAP)</a>.</p>

          </div>
        </div>
      </v-card-title>
    </v-card>
  </v-flex>
</v-layout>

</div>
</template>

<script>

export default {
  data () {
    return {
    }
  }
}
</script>
